"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const utils_1 = require("./utils");
function estimateMaxSpendable({ account, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
parentAccount, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
transaction, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const balance = account.balance;
        const estimatedFees = yield (0, utils_1.getEstimatedFees)();
        let maxSpendable = balance.minus(estimatedFees);
        // set max spendable to 0 if negative
        // for cases where the user's account balance is smaller than the estimated fee
        if (maxSpendable.isLessThan(0)) {
            maxSpendable = new bignumber_js_1.default(0);
        }
        return Promise.resolve(maxSpendable);
    });
}
exports.default = estimateMaxSpendable;
//# sourceMappingURL=js-estimateMaxSpendable.js.map